import  React from 'react'
import * as H from 'history'
import { Alert } from 'react-bootstrap'
import { ISupportSpinner } from '../../../shared/Ajax'
import {
  BooleanRadioButtonField, Checkbox, MoneyField, MultiLineField, NumberField,
  NumericRadioButtonField, ReadOnly, TextField, TextRadioButtonField,
  validateFields, yesNoDataSource, FormItem, yesNoNADataSource,
  Label,
}
  from '../../../shared/fields'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import { MilestoneReportModel } from '../../../models/MilestoneReportModel'
import { MilestoneReportController } from '../../../controllers/MilestoneReportController'
import { formatMoneyForDisplay } from '../../../shared/Utility'
import { MaskedField } from '../../../shared/fields/MaskedField'
import { MilestoneModel } from '../../../models/MilestoneModel'
import { Backdrop } from '../../../shared/Backdrop'

export interface Props {
    history: H.History
    model: MilestoneReportModel
    preview?: boolean
    onChange: { (changes: Partial<MilestoneModel>, callback?: { (): any }): any }
}

export interface State {
    loading: boolean
}

const increaseDecreaseRemainSameNADataSource = [{ value: 'Increased', label: 'Increased' }, { value: 'Decreased', label: 'Decreased' }, { value: 'Remained the same', label: 'Remained the same' }, { value: 'Not applicable', label: 'Not applicable' }]

export class GeneralRequirement extends React.Component<Props, State> implements
    ISupportSpinner {
    ajax: MilestoneReportController
    grantEligibilityDeclaration: Checkbox
    grantEligibilityChangeOfCircumstances: MultiLineField
    grantActivityProceeding: NumericRadioButtonField
    grantActivityProceedingDescription: MultiLineField
    progressTracking: NumericRadioButtonField
    progressTrackingDescription: MultiLineField
    isBankDetailsCorrect: BooleanRadioButtonField
    isAtoCompliant: BooleanRadioButtonField
    bsbNumber: MaskedField
    financialInstitute: TextField
    accountNumber: TextField
    bankName: TextField
    exportIncome: MoneyField
    annualIncome: MoneyField
    exportIncomeChangedBy: TextRadioButtonField
    exportIncomeChangedDetails: MultiLineField
    totalEmployees: NumberField
    exportPromotionalDetails: MultiLineField

    constructor(props: Props) {
      super(props)

      this.ajax = new MilestoneReportController()

      this.state = {
        loading: false,
      }
    }

    componentDidUpdate(prevProps: Props) {
      const { model, onChange } = this.props
      if (model.milestoneModel.bsbNumber !== prevProps.model.milestoneModel.bsbNumber
            && model.milestoneModel.bsbNumber
            && (model.milestoneModel.bsbNumber.match(/\d/g) || '').length === 6) {
        this.ajax.bsbSearch(this,
          model.milestoneModel.bsbNumber,
          (bsb) => {
            if (bsb) {
              onChange({
                financialInstitute: `${bsb.institutionCode}-${bsb.institutionName}`,
                bsbInvalid: false,
              })
            } else {
              onChange({
                financialInstitute: '',
                bsbInvalid: true,
              })
            }
          })
      }
    }

    next = () => {
      const { loading } = this.state
      if (loading) {
        return
      }

      validateFields((res) => {
        if (res) {
          const { model, history, onChange } = this.props
          // const invalidDocuments = getInvalidFileBlobIds(model)
          // const updatedModel = { ...JSON.parse(JSON.stringify(model)), invalidDocuments }
          this.ajax.saveMilestoneReport(this,
            model.milestoneModel,
            (d) => {
              onChange({ ...model.milestoneModel, ...d })
              history.push(`/milestone-report/${model.milestoneModel.milestoneReportID}/expenditure`)
            })
        }
      },
      this.grantEligibilityDeclaration,
      this.grantActivityProceeding,
      this.grantActivityProceedingDescription,
      this.progressTracking,
      this.progressTrackingDescription,
      this.isBankDetailsCorrect,
      this.bsbNumber,
      this.financialInstitute,
      this.accountNumber,
      this.bankName,
      this.exportIncome,
      this.exportIncomeChangedBy,
      this.exportIncomeChangedDetails,
      this.totalEmployees,
      this.exportPromotionalDetails,
      this.annualIncome,
      this.isAtoCompliant)
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    render() {
      const {
        model, onChange, history, preview,
      } = this.props
      const { loading } = this.state
      return (
        <>
          <FormItem label={(
            <span className="form-content-preview" style={{ fontSize: this.props.preview ? '10pt' : 'inherits' }}>
              <h3>General Reporting Requirements</h3>
              <Alert className="emdg-page-alerts">
                <strong>
                  The online milestone report form supersedes the template version that appears in the Schedule of your Grant Agreement.
                </strong>
                <br />
                <br />
                The report must be completed even if you have not incurred eligible expenditure on export promotional activities for this reporting period.
                <br />
                <br />
                A representative, authorised by the grantee, must complete and submit this report.
                <br />
                You can enter the required information in stages and submit when it is complete.
                <br />
                The Commonwealth reserves the right to amend or adjust the requirements.
                <br />
                <br />
                You MUST click the SUBMIT button on the Submit page to submit your milestone report.
                <br />
                Your milestone report will NOT be received by Austrade until you click the SUBMIT button.
                <br />
                After you submit your milestone report you will receive a Milestone Report reference number.
              </Alert>

              <ReadOnly
                label="Reporting Period"
                labelContent={model.grantAgreementDetailModel.reportingPeriod}
              />

              <ReadOnly
                label="Total Grant Amount"
                labelContent={formatMoneyForDisplay(parseFloat(model.grantAgreementDetailModel.totalGrantAmount))}
              />

              <ReadOnly
                label="Maximum amount  for this Reporting Period"
                labelContent={formatMoneyForDisplay(parseFloat(model.grantAgreementDetailModel.maximumAmountForReportingPeriod))}
              />
            </span>
)}
          />
          {/* <ReadOnly
                        label="Total grant monies received by the Grantee to date"
                        labelContent={formatMoneyForDisplay(parseFloat(model.grantAgreementDetailModel.totalGrantMoniesReceived))}
                    /> */}

          <h3>Grant eligibility</h3>
          <Label label="1. Please complete the declaration." preview={preview} />
          <div className="form-item">
            <Checkbox
              ref={(r) => { this.grantEligibilityDeclaration = r }}
              id="grantEligibilityDeclaration"
              label="I confirm and declare I have complied with the provisions of the Grant Agreement and the EMDG Act, the EMDG Rules and Grant Guidelines that:"
              description={(
                <ul className="mt-0">
                  <li className="mt-0">I have a valid ABN</li>
                  <li className="mt-0">I have no disqualifying convictions</li>
                  <li className="mt-0">I am not under insolvency administration (this does not apply to Representative Bodies as defined in the Act and Rules)</li>
                  <li className="mt-0">I have a designated connection (refer to the relevant section in the EMDG Guidelines) to eligible product(s) or I am a Representative Body and my members have a designated connection to the eligible product(s)</li>
                  <li className="mt-0">I have contributed at least 50% of my own monies to the grant activities</li>
                </ul>
                          )}
              value={model.milestoneModel.grantEligibilityDeclaration}
              onChange={(val) => onChange({ grantEligibilityDeclaration: val || null })}
              requiredMessage="This field is required"
              required
              preview={preview}
            />

            <BooleanRadioButtonField
              ref={(r) => { this.isAtoCompliant = r }}
              id="isAtoCompliant"
              value={model.milestoneModel.isAtoCompliant}
              label="2. At the time of submitting the milestone report, I declare that I am compliant with all the relevant Australian Taxation Office (ATO) legislation, rulings and guidelines"
              onChange={(isAtoCompliant) => onChange({ isAtoCompliant })}
              dataSource={yesNoDataSource}
              required
              preview={preview}
            />
            <Alert className="emdg-page-alerts">
              During the assessment process we may require you to provide evidence that you have satisfied your tax obligations.
            </Alert>

            <MultiLineField
              ref={(r) => { this.grantEligibilityChangeOfCircumstances = r }}
              id="grantEligibilityChangeOfCircumstances "
              label="3. Please describe any change of circumstances to your business that may affect your eligibility for the reporting period."
              value={model.milestoneModel.grantEligibilityChangeOfCircumstances}
              onChange={(grantEligibilityChangeOfCircumstances) => onChange({ grantEligibilityChangeOfCircumstances })}
              maxLength={3000}
              preview={preview}
            />
          </div>

          {/* <h3>Total number of employees</h3> */}
          <div className="form-item">
            <NumberField
              ref={(r) => { this.totalEmployees = r }}
              id="totalEmployees"
              label="4. What is the total number of Australian-based employees of your business for the Reporting Period? Include all full and part time employees, contractors and working directors based in Australia."
              value={model.milestoneModel.totalEmployees}
              onChange={(totalEmployees) => onChange({ totalEmployees })}
              required
              min={1}
              max={32765}
              wholeNumbersOnly
              preview={preview}
            />
          </div>

          <div className="form-item">
            <MoneyField
              ref={(r) => { this.annualIncome = r }}
              id="annualIncome"
              label="5. What is the annual income (i.e., your total turnover including sales) of your business for this reporting period?"
              value={model.milestoneModel.annualIncome}
              onChange={(annualIncome) => onChange({ annualIncome })}
              required
              preview={preview}
              allowZero
            />
          </div>

          <h3>Grantee bank account details</h3>
          <div className="form-item">
            <BooleanRadioButtonField
              ref={(r) => { this.isBankDetailsCorrect = r }}
              id="isBankDetailsCorrect"
              value={model.milestoneModel.isBankDetailsCorrect}
              label="6. I confirm the bank account details as per Section D of the Grant Agreement are correct."
              onChange={(isBankDetailsCorrect) => onChange({ isBankDetailsCorrect })}
              dataSource={yesNoDataSource}
              required
              preview={preview}
            />

            <ReadOnly
              label="BSB Number"
              labelContent={model.crmPaymentDetails.bsb}
            />
            <ReadOnly
              label="Financial institution and branch"
              labelContent={model.crmPaymentDetails.financialInstitute}
            />
            <ReadOnly
              label="Account number"
              labelContent={model.crmPaymentDetails.accountNumber}
            />
            <ReadOnly
              label="Name of bank account"
              labelContent={model.crmPaymentDetails.bankName}
            />

            {model.milestoneModel.isBankDetailsCorrect === false && (
            <>
              <div className="form-item">6.a. Please provide your new bank details.</div>
              <MaskedField
                ref={(r) => { this.bsbNumber = r }}
                id="bsbNumber"
                label="BSB Number"
                value={model.milestoneModel.bsbNumber}
                onChange={(bsbNumber) => onChange({ bsbNumber })}
                block={false}
                mask="999-999"
                required
                preview={preview}
                errorMessage={model?.milestoneModel?.bsbNumber && (model.milestoneModel.bsbNumber.match(/\d/g) || '').length !== 6 && 'Bsb number must be 6 digits'}
              />

              {model.milestoneModel.bsbInvalid && (
              <Alert className="emdg-page-alerts emdg-page-alerts--warning ">
                The BSB you entered was not on our list. We will be in contact to confirm the details once the report is lodged.
              </Alert>
              )}
              <TextField
                ref={(r) => { this.financialInstitute = r }}
                id="financialInstitute"
                label="Financial Institution and Branch"
                value={model.milestoneModel.financialInstitute}
                onChange={(financialInstitute) => onChange({ financialInstitute })}
                required
                preview={preview}
                maxLength={80}
              />
              <TextField
                ref={(r) => { this.accountNumber = r }}
                id="accountNumber"
                label="Account number"
                value={model.milestoneModel.accountNumber}
                onChange={(accountNumber) => onChange({ accountNumber })}
                required
                maxLength={30}
                preview={preview}
                errorMessage={model?.milestoneModel?.accountNumber && (model.milestoneModel.accountNumber.match(/^\d+$/) || '').length === 0 && 'Account number must contain only numbers'}
              />
              <TextField
                ref={(r) => { this.bankName = r }}
                id="bankName"
                label="Name of bank account"
                value={model.milestoneModel.bankName}
                onChange={(bankName) => onChange({ bankName })}
                required
                preview={preview}
                maxLength={80}
              />
            </>
            )}
          </div>

          <h3>Plan to market</h3>
          <div className="form-item">
            <NumericRadioButtonField
              ref={(r) => { this.grantActivityProceeding = r }}
              id="grantActivityProceeding"
              value={model.milestoneModel.grantActivityProceeding}
              label="7. Since your initial application, have you had any changes or proposing to change your plan to market?"
              onChange={(grantActivityProceeding) => onChange({ grantActivityProceeding })}
              dataSource={yesNoNADataSource}
              required
              preview={preview}
            />
            {(model.milestoneModel.grantActivityProceeding === 2) && (
            <Alert className="emdg-page-alerts emdg-page-alerts--warning ">
              Please note this only applies to Representative Bodies providing training activities.
              <br />
              <br />
              You must complete this section accurately if you are a Tier 1, Tier 2, or Tier 3 grantee, or a Representative Body undertaking promotional activities on behalf of your members.
            </Alert>
            )}

            <MultiLineField
              ref={(r) => { this.grantActivityProceedingDescription = r }}
              id="grantActivityProceedingDescription "
              label="Please describe any changes or proposed changes to:"
              description={(
                <ul className="mt-0">
                  <li className="mt-0">Eligible product/s</li>
                  <li className="mt-0">Business goals and promotion activities</li>
                  <li className="mt-0">Planned marketing expenditure in future year/s</li>
                  <li className="mt-0">Export markets</li>
                </ul>
                          )}
              value={model.milestoneModel.grantActivityProceedingDescription}
              onChange={(grantActivityProceedingDescription) => onChange({ grantActivityProceedingDescription })}
              maxLength={3000}
              required
              preview={preview}
            />
          </div>

          <h3>Export income</h3>
          <div className="form-item">
            <MoneyField
              ref={(r) => { this.exportIncome = r }}
              id="exportIncome"
              label="8. What is your export income for the reporting period?"
              value={model.milestoneModel.exportIncome}
              onChange={(exportIncome) => onChange({ exportIncome })}
              required
              preview={preview}
              allowZero
            />
            <TextRadioButtonField
              ref={(r) => { this.exportIncomeChangedBy = r }}
              id="exportIncomeChangedBy"
              value={model.milestoneModel.exportIncomeChangedBy}
              label="9. Has your export income increased, decreased or remained the same since the last Reporting Period?"
              onChange={(exportIncomeChangedBy) => onChange({ exportIncomeChangedBy })}
              dataSource={increaseDecreaseRemainSameNADataSource}
              required
              preview={preview}
            />

            {(model.milestoneModel.exportIncomeChangedBy === 'Not applicable') && (
            <Alert className="emdg-page-alerts emdg-page-alerts--warning ">
              Please note this only applies to Tier 1 and Representative Bodies.
            </Alert>
            )}
          </div>

          <NextBackButtons
            onBack={() => {
              if (confirm('Changes you made may not be saved.')) {
                history.goBack()
              }
            }}
            onNext={this.next}
            preview={preview}
          />
          <Backdrop on={loading} />
        </>
      )
    }
}
